module.exports = __webpack_public_path__ + "static/img/ntradition_img01.cc85fdb4.jpg";